export default {
  'ROBOT:EXCEPTION':
    'Uh oh! Something went wrong at our side. Don`t worry, it`s not you. Sorry about that.',
  'ROBOT:NOANSWER': 'Sorry,I can`t understand, you can ask in a different way',
  'ROBOT:SUGGEST': 'I guess you want to say',
  'LOGIN:SUCCESS': 'Awesome! You`re logged in now!',
  'KNOWLEDGE:GOOD': 'What else can I help you with?',
  'KNOWLEDGE:BAD':
    'Seems my response wasn`t useful for you. Would you like to rephrase the question or ask something else?',
  'SHIPPING:ADDRESS': 'Shipping Address',
  'ROBOT:RECOMMEND': 'Do you still want to know the following：',
  'ROBOT:RECOMMEND:RELATED':
    'Please pick a suggestion that best matches your question!',
  'TRACKING:DETAIL': 'Tracking Details',
  'ORDER:STATUS': 'Order Status',
  'CANCEL:ITEM': 'Cancel Item',
  'BUTTON:MORE': 'View More',
  'SHOW:ALLORDERS': 'Show all of my orders',
  'ROBOT:WELCOME': '...or answer questions you have about Lazada.',
  'ROBOT:LIVEAGENT': 'I`d prefer to Chat with a Live Agent',
  'PAGE:404': 'Sorry,your page was taken away',
  'WORD:ITEM': 'Item',
  'FEEDBACK:QUESTION': 'Was this helpful?',
  'FEEDBACK:THANKS': 'Thank you!',
  'LIVE:AGENT': 'live agent',
  'BUTTON:LOGIN': 'Login',
  'BUTTON:SEND': 'Send',
  openOrder: n => `Alright, you\`ve got ${n} open orders`,
  openOrderToCancel: n => `Alright, you\`ve got ${n} open orders`,
  indexOrder: (o, n) => `Order ${o} of ${n}`,
  packageDetail: (o, n) => `Details for order ${o} with ${n} packages`,
  orderDetail: (o, p, n) => `Order number  ${o} placed ${p} has ${n} items`,
  packageOrder: (p, n) => `Package ${p} of ${n}`,
  tracking: (p, n) =>
    `Here \`s your tracking details for <span class="bold">Package  ${p}</span>  of order number <span class="bold">${n}</span>`,
};



// WEBPACK FOOTER //
// ./src/bu/pc/locales/en-us.js